import { useEffect, useState } from "react";

import { AlertEnum, getAlertStatus } from "utils/horse";

interface IChartState {
  status: AlertEnum;
  percent: number;
}

export function useChartState(value: number, capacity: number): IChartState {
  const [percent, setPercent] = useState<number>(0);
  const [status, setStatus] = useState<AlertEnum>(AlertEnum.na);

  const getChartFillPercent = count => {
    if (!Number.isInteger(count)) {
      return 100;
    }
    const step = Math.round(count * (100 / capacity));
    return Math.min(step, 100);
  };

  useEffect(() => {
    setStatus(getAlertStatus(value, capacity));
    setPercent(getChartFillPercent(Number.isNaN(value) ? 0 : value));
  }, [value]);

  return {
    status,
    percent
  };
}
